import type { VisitStatus } from '@/store/visitsSlice';

export const VISIT_STATUS_LABELS: Record<VisitStatus, string> = {
  pending: 'Ожидает',
  accepted: 'Принят',
  in_progress: 'В работе',
  submitted: 'Отправлен',
  processing: 'Обработка',
  processed: 'Обработан',
  approved: 'Утверждён',
  rejected: 'Отклонён',
  signed: 'Подписан',
  paid: 'Оплачен',
  finished: 'Завершён',
  cancelled: 'Отменён',
  failed: 'Ошибка',
};

export type ChipColor = 'default' | 'accent' | 'success' | 'warning' | 'danger';

export const VISIT_STATUS_COLORS: Record<VisitStatus, ChipColor> = {
  pending: 'default',
  accepted: 'accent',
  in_progress: 'accent',
  submitted: 'accent',
  processing: 'warning',
  processed: 'warning',
  approved: 'success',
  rejected: 'danger',
  signed: 'success',
  paid: 'success',
  finished: 'default',
  cancelled: 'default',
  failed: 'danger',
};
